<script setup lang="ts">
import { onMounted, Ref, ref } from 'vue';

const slots = defineSlots<{
  title(props: object): any;
  body(props: object): any;
}>();

const show = ref(false);
const titleButton: Ref<HTMLSpanElement | undefined> = ref();
const hideTimeout = ref<number | null>(null);
const position = ref({
  left: 0,
  top: 0,
});

onMounted(() => {
  calculatePosition();
});

function calculatePosition() {
  const { x: left = 0, y, width, height } = titleButton.value?.getBoundingClientRect() || {};
  position.value = { left: left + (width || 0), top: (y || 0) + (height || 0) };
}

function mouseEnter() {
  if (hideTimeout.value) {
    clearTimeout(hideTimeout.value);
    hideTimeout.value = null;
  }
  calculatePosition();
  show.value = true;
}

function mouseLeave() {
  hideTimeout.value = window.setTimeout(() => {
    show.value = false;
  }, 100);
}
</script>

<template>
  <span ref="titleButton" class="relative" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <slot name="title"></slot>

    <Teleport v-if="show" to="body" @mouseenter="mouseEnter">
      <span
        :style="{ left: position.left, top: position.top }"
        class="text-caption-s fixed z-[100006] flex max-w-[264px] rounded-8 bg-white px-xm pb-s pt-[14px] text-gray-900 shadow-x dark:bg-gray-900 dark:text-gray-400"
        @mouseenter="mouseEnter"
        @mouseleave="mouseLeave"
      >
        <slot name="body"></slot>
      </span>
    </Teleport>
  </span>
</template>
